import React from 'react';
import ReactEcharts from 'echarts-for-react';
import PropTypes from 'prop-types';

function GraphNetworkGroup (props) {
  const { members, typeDisplay } = props.el;
  let reports = [];
  const rpts = props.reports.slice();

  if (typeDisplay && typeDisplay !== 'ALL' && members) {
    reports = rpts.filter(rpt => members.includes(rpt._id));
  } else {
    reports = [...rpts];
  }

  const networkGroup = reports.reduce((result, networkGroup) => {
    const { _id, name, free, busy, incoming, outgoing } = networkGroup;
    if (Object.keys(result).includes(_id)) {
      result[_id].labels = result[_id].labels.concat(['']);
      result[_id].series.free = result[_id].series.free.concat([free]);
      result[_id].series.busy = result[_id].series.busy.concat([busy]);
      result[_id].series.incoming = result[_id].series.incoming.concat([
        incoming
      ]);
      result[_id].series.outgoing = result[_id].series.outgoing.concat([
        outgoing
      ]);
    } else {
      result[_id] = {};
      result[_id].title = name;
      result[_id].labels = [''];
      result[_id].series = {
        free: [free],
        busy: [busy],
        incoming: [incoming],
        outgoing: [outgoing]
      };
    }
    return result;
  }, {});

  return (
    <div>
      {Object.keys(networkGroup).map((_id, i) => {
        const type = 'bar';

        const label = {
          normal: {
            show: true,
            position: 'insideBottom',
            fontSize: 16,
            color: '#000',
            verticalAlign: 'center',
            rotate: 0,
            distance: 25,
            fontWeight: 'bold'
          }
        };

        const configs = {
          title: {
            text: networkGroup[_id].title,
            left: 'center',
            textStyle: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          grid: { left: '12%', right: '12%', bottom: '15%' },
          animationDuration: 0,
          hoverAnimation: false,
          cursor: 'default',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: { top: '15%' },
          xAxis: {
            data: [...networkGroup[_id].labels],
            axisLabel: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          yAxis: {},
          series: [
            {
              name: 'LVR',
              type,
              barGap: 0,
              label,
              color: '#4d94ff',
              legendHoverLink: false,
              data: [...networkGroup[_id].series.free]
            },
            {
              name: 'OCP',
              type,
              label,
              color: '#da1616',
              data: [...networkGroup[_id].series.busy]
            },
            {
              name: 'IN',
              type,
              label,
              color: '#16df23',
              data: [...networkGroup[_id].series.incoming]
            },
            {
              name: 'OUT',
              type,
              label,
              color: '#e9df20',
              data: [...networkGroup[_id].series.outgoing]
            }
          ]
        };
        const panel = document.getElementById(`panel_${props.el.i}`);
        let itemWidth = 0;
        if (panel) {
          const widthScreen = panel.offsetWidth;
          if (widthScreen < 1642 && widthScreen > 1104) {
            itemWidth = (widthScreen - 40) / 2;
          } else if (widthScreen < 1105) {
            itemWidth = widthScreen - 40;
          } else {
            itemWidth = (widthScreen - 40) / 3;
          }
        }
        return (
          <ReactEcharts
            key={i}
            option={configs}
            style={{ width: `${itemWidth}px`, height: '250px', float: 'left' }}
          />
        );
      })}
    </div>
  );
}

export default GraphNetworkGroup;

GraphNetworkGroup.propTypes = {
  el: PropTypes.object,
  reports: PropTypes.array
};
